<template>
  <div>
    <div class="text-center" v-if="loading">
      <b-spinner class="ms-2" variant="primary"></b-spinner>
    </div>
    <div v-if="tabela && !loading">
      <div>
        <b-table
          responsive="sm"
          :items="dadosEnderecos"
          :fields="camposEndereco"
          per-page="1000"
          striped
        >
          <template #cell(options)="data">
            <div class="d-flex justify-content-end">
              <b-button
                size="sm"
                class="me-1"
                variant="primary"
                @click="editarEndereco(data.item)"
                data-tooltip="Editar"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-pencil"></i>
              </b-button>
              <b-button
                size="sm"
                class="me-1"
                variant="danger"
                @click="excluirEndereco(data.item)"
                data-tooltip="Excluir"
                data-tooltip-location="left"
              >
                <i class="mdi mdi-trash-can"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div>
        <div class="mt-1 d-flex justify-content-end">
          <b-button variant="info" class="mt-5 mb-3" @click="incluir()">
            <i class="mdi mdi-plus"></i>
            Incluir
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="navegar('idiomas', false)"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            variant="primary"
            class="mt-1"
            @click="navegar('contatos', true)"
            data-tooltip="Próximo"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-right-circle font-size-15"></i>
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="!tabela && !loading">
      <div class="row">
        <div class="col-md-2">
          <b-form-group
            class="mb-3"
            label="CEP"
            invalid-feedback="Digite um CEP válido"
          >
            <b-form-input
              v-model="dados.cep"
              type="text"
              v-mask="'#####-###'"
              maxlength="9"
              autocomplete="off"
              @input="aoAlterarCep"
              @blur="consultaCep()"
              :state="validacaoCep"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-5" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Município - UF">
            <b-form-input
              v-model="dados.municipioUf"
              readonly
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-5" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Bairro">
            <b-form-input
              v-model="dados.dsBairro"
              :disabled="!cepSimples"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Endereço">
            <b-form-input
              v-model="dados.dsEndereco"
              :disabled="!cepSimples"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-2" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="N°">
            <b-form-input
              v-model="dados.nrEndereco"
              autocomplete="off"
              trim
              maxlength="5"
              type="text"
            ></b-form-input>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="this.mostraMunicipio">
          <b-form-group class="mb-3" label="Complemento">
            <b-form-input
              v-model="dados.dsComplemento"
              type="text"
              trim
              maxlength="50"
            ></b-form-input>
            <div class="text-center">
              <p
                v-if="dados.dsComplemento"
                class="badge position-absolute"
                :class="{
                  'bg-success': dados.dsComplemento.length !== 50,
                  'bg-danger': dados.dsComplemento.length === 50,
                }"
              >
                {{ dados.dsComplemento.length }} / 50
              </p>
            </div>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div>
            <b-form-checkbox
              id="checkbox-1"
              v-model="dados.principal"
              :unchecked-value="false"
              :value="true"
              :disabled="disabledPrincipal == true"
              plain
            >
              Endereço Principal
            </b-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="mt-1 d-flex justify-content-between">
          <b-button
            class="mt-1 me-1"
            @click="tabela = true"
            data-tooltip="Voltar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-arrow-left-circle font-size-15"></i>
          </b-button>
          <b-button
            class="mt-1 me-1"
            variant="success"
            @click="salvar()"
            :disabled="disabledSalvar"
            data-tooltip="Salvar"
            data-tooltip-location="bottom"
          >
            <i class="mdi mdi-content-save"></i>
            <b-spinner
              variant="primary"
              small
              class="ms-2"
              v-if="loadingSalvar"
            ></b-spinner>
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const capitalizeString = (str) => {
  return str
    .split(" ")
    .map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};
export default {
  data() {
    return {
      dados: {
        sqEndereco: "",
        dsEndereco: "",
        cep: "",
        municipioUf: "",
        dsBairro: "",
        cdTipo: "2",
        sqRegiao: "",
        nrEndereco: "",
        dsComplemento: "",
        principal: "",
      },
      disabledPrincipal: "",
      camposEndereco: [
        {
          key: "NRCEP",
          label: "CEP",
        },
        {
          key: "NMREGIAO",
          label: "Cidade",
          formatter: (value) => {
            const partes = value.split(" - ");
            const parte1 = capitalizeString(partes[0]);
            const parte2 = partes[1].toUpperCase();
            return parte1 + " - " + parte2;
          },
        },
        {
          key: "DSENDERECO",
          label: "Endereço",
          formatter: (value) => {
            return capitalizeString(value);
          },
        },
        {
          key: "NRENDERECO",
          label: "N°",
        },
        {
          key: "PRINCIPAL",
          label: "Principal",
        },
        {
          key: "options",
          label: "",
        },
      ],
      dadosEnderecos: [],
      cidades: [],
      cdIbge: "",
      loading: true,
      tabela: true,
      mostraMunicipio: false,
      validacaoCep: null,
      avancar: null,
      cepSimples: false,
      ultimoCepConsultado: "",
      loadingSalvar: false,
      disabledSalvar: false,
    };
  },

  created() {
    this.buscarEndereco();
  },

  methods: {
    buscarEndereco() {
      this.$http
        .get("api/cadastroCandidato/buscarEndereco")
        .then((response) => {
          this.dadosEnderecos = response.data;
          this.loading = false;
        });
    },

    navegar(nomeAba, direcao) {
      this.$emit("navegar", nomeAba, direcao);
    },

    aoAlterarCep() {
      const cep = (this.dados.cep || "").replace(/\D/g, "");

      if (cep.length < 8) {
        this.ultimoCepConsultado = "";
        this.validacaoCep = null;
        this.mostraMunicipio = false;
        return;
      }

      this.consultaCep();
    },

    consultaCep() {
      const cep = (this.dados.cep || "").replace(/\D/g, "");
      var baseUrl = "https://viacep.com.br/ws/";

      if (cep.length === 8 && cep !== this.ultimoCepConsultado) {
        this.ultimoCepConsultado = cep;
        this.dados.dsEndereco = "";
        this.dados.dsBairro = "";
        const url = baseUrl + cep + "/json/";
        axios
          .get(url)
          .then((response) => {
            if (response.data.erro) {
              this.validacaoCep = false;
              this.mostraMunicipio = false;
              this.cepSimples = false;
              this.cdIbge = "";
              this.$tools.alerta("CEP não encontrado.", "warning");
              return;
            }
            this.validacaoCep = true;
            this.cdIbge = response.data.ibge;
            var aux = response.data;
            var montaNome = capitalizeString(aux.localidade) + " - " + aux.uf;
            this.dados.municipioUf = montaNome.toString();
            this.dados.dsBairro = aux.bairro;
            if (aux.logradouro) {
              this.cepSimples = false;
              this.dados.dsEndereco = aux.logradouro;
            } else {
              this.cepSimples = true;
            }
            this.mostraMunicipio = true;
          })
          .catch(() => {
            this.validacaoCep = false;
            this.mostraMunicipio = false;
            this.cepSimples = false;
            this.cdIbge = "";
            this.ultimoCepConsultado = "";
            this.$tools.alerta(
              "Não foi possível consultar o CEP. Tente novamente em instantes.",
              "error"
            );
          });
      }
    },

    salvar() {
      var item = {};
      var cep = this.dados.cep.replace("-", "");
      this.loadingSalvar = true;
      this.disabledSalvar = true;
      if (
        !this.dados.dsEndereco ||
        !this.dados.dsBairro ||
        !this.dados.nrEndereco ||
        !this.dados.cep
      ) {
        this.$tools.alerta(
          "Por favor, para continuar preencha todos os campos",
          "warning"
        );
        this.loadingSalvar = false;
        this.disabledSalvar = false;
        return;
      }

      if (this.dados.sqEndereco) {
        item.sqEndereco = this.dados.sqEndereco;
      } else {
        item.sqEndereco = "";
      }
      item.dsEndereco = this.dados.dsEndereco;
      item.nrCep = parseInt(cep);
      item.dsBairro = this.dados.dsBairro;
      item.nrEndereco = this.dados.nrEndereco;
      item.cdTipo = this.dados.cdTipo;
      item.sqRegiao = this.dados.sqRegiao;
      item.enderecoAbrev = null;
      item.dsComplemento = this.dados.dsComplemento;
      item.cdBco = "";
      item.cdFil = "";
      item.nrAgencia = "";
      item.sqProdutor = "";
      item.cdIbge = this.cdIbge;
      if (this.dados.principal == true) {
        item.principal = "S";
      } else {
        item.principal = "N";
      }

      this.$http
        .post("api/cadastroCandidato/salvarEndereco", item)
        .then(() => {
          this.$tools.alerta("Salvo com sucesso", "success");
          this.loadingSalvar = false;
          this.disabledSalvar = false;
          this.$emit("carregarNivelPerfil");
          this.buscarEndereco();
          this.tabela = !this.tabela;
        })
        .catch(() => {
          this.loadingSalvar = false;
          this.disabledSalvar = false;
          this.$tools.alerta("Não foi possível cadastrar o endereço", "error");
        });
    },

    incluir() {
      (this.dados.sqEndereco = ""),
        (this.dados.dsEndereco = ""),
        (this.dados.cep = ""),
        (this.dados.municipioUf = ""),
        (this.dados.dsBairro = ""),
        (this.dados.nrEndereco = ""),
        (this.dados.dsComplemento = ""),
        (this.dados.sqRegiao = "");
      this.tabela = false;
      this.mostraMunicipio = false;
      this.cepSimples = false;
      this.validacaoCep = null;
      this.ultimoCepConsultado = "";
      if (this.dadosEnderecos.length == 0) {
        this.dados.principal = true;
        this.disabledPrincipal = true;
      } else {
        this.dados.principal = false;
        this.disabledPrincipal = "";
      }
    },

    editarEndereco(item) {
      this.dados.cep = item.NRCEP;
      this.dados.municipioUf =
        capitalizeString(item.NMREGIAO.slice(0, length - 2)) +
        item.NMREGIAO.substring(item.NMREGIAO.length - 2);
      this.dados.dsBairro = item.DSBAIRRO;
      this.dados.nrEndereco = item.NRENDERECO;
      this.dados.dsComplemento = item.DSCOMPLEMENTO;
      this.dados.dsEndereco = item.DSENDERECO;
      this.dados.principal = item.PRINCIPAL === "Sim" ? true : false;
      this.disabledPrincipal = item.PRINCIPAL === "Sim" ? true : "";
      this.dados.sqEndereco = item.SQENDERECO;
      this.dados.sqRegiao = item.SQREGIAO;
      this.tabela = false;
      this.mostraMunicipio = true;
    },

    excluirEndereco(item) {
      if (item.PRINCIPAL === "Sim") {
        this.$tools.alerta(
          "Não é possível excluir um endereço principal",
          "warning"
        );
      } else {
        this.$http
          .get("api/cadastroCandidato/excluirEndereco/" + item.ID)
          .then(() => {
            this.$tools.alerta("Excluído com sucesso", "success");
            this.buscarEndereco();
          })
          .catch((err) => {
            this.$tools.alerta(err.response.data.message, "error");
          });
      }
    },
  },
};
</script>
